import PropTypes from 'prop-types'
import { useCallback, useEffect, useState } from "react"

import { ChevronDownIcon, Loader2 } from 'lucide-react'
import { Button, FormGroup, Input, Label, DefaultPopover, Separator, DefaultTooltip } from 'twyne-new.ui';

const propTypes = {
  onExport: PropTypes.func,
};

function Export({ onExport }) {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(null)
  const [credential, setCredential] = useState('')

  const handleExport = useCallback(async credential => {
    setLoading(true)

    await onExport(credential)

    setLoading(false)
    setShow(true)
    setSuccess(true)

    setTooltipOpen(true)
    setTimeout(() => {
      setTooltipOpen(false)
    }, 3000)
  }, [onExport])

  useEffect(() => {
    setTimeout(() => {
      setSuccess(null)
      setShow(false)
    }, 5000)
  }, [show])

  return <DefaultPopover
    wrapperProps={{ open: show, onOpenChange: setShow }}
    content
    trigger={<>
      <DefaultTooltip side='left' open={tooltipOpen} content={tooltipOpen && success ? "The file is being processed and will be sent to your email shortly. Please, check your email inbox." : "Something went wrong. Please, try again later."}>
        <Button variant='outline' size='lg'>
          {loading ? <Loader2 className='animate-spin' size='16' /> : <>
            Export
            <ChevronDownIcon size='16' />
          </>}
        </Button>
      </DefaultTooltip>
    </>}
  >
    <span className='text-md'>Export File</span>
    <Separator className='m-0 my-2' />
    <FormGroup>
      <Label>Zip Password</Label>
      <Input required name="credential" value={credential}
        onChange={e => setCredential(e.target.value)} />
    </FormGroup>
    <Button className='mt-2' color="accent" block onClick={() => handleExport(credential)}>
      Export
    </Button>
  </DefaultPopover>
}

Export.propTypes = propTypes

export default Export
